import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../../symbols/HTHSymbol";
import {HTHSafeSymbol} from "../../symbols/HTHSafeSymbol";
import {HTHScatterSymbol} from "../../symbols/HTHScatterSymbol";
import {HTHGameMode} from "../../server/HTHGameMode";
import {HTHSound} from "../../sound/HTHSound";

export class HTHScatterWinPresentation implements SimplePresentation {

    constructor() {
    }

    shouldRun(): boolean {
        return (HTH.model.isNormal || HTH.model.mode === HTHGameMode.NORMAL_AVALANCHE) && HTH.model.nextMode === HTHGameMode.FREESPIN;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});

        controller.setSkipCallback();

        tl.add(() => {
            HTHSound.playTrack(HTHSound.SCATTER_WIN);
        });

        [0, 1, 2, 3, 4, 5].forEach((reelId: number) => {
            [0, 1, 2, 3].forEach((symId: number) => {
                const sym: HTHSymbol = HTH.reelArea.getSymbol([reelId, symId]);
                if (sym.symName === "SA") {
                    tl.add(() => {
                        sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                    }, 0);
                    tl.add((<HTHSafeSymbol>sym).ssSymbolAnimChange("win", true, false), 0);
                    tl.add(() => {
                        sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.scatterLayer);
                    }, "postWin");
                } else if (sym.symName === "SC") {
                    tl.add(() => {
                        sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.winLayer);
                    }, 0);
                    tl.add((<HTHScatterSymbol>sym).playSpineAnim("win", true, false), 0);
                    tl.add(() => {
                        sym.movetoParticularMaskedLayer(HTH.reelArea.allReels[sym.reelId].reelView.reelLayers.scatterLayer);
                    }, "postWin");
                }
            });
        });


        tl.to(this, {duration: 0.001});
        tl.addLabel("postWin");
    }

}